//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {};
  },

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    message: function () {
      return this.$store.state['custom-notification']?.customNotificationMessage;
    },
    type: function () {
      return this.$store.state['custom-notification']?.customNotificationType || "error";
    },
    buttonCloseLink: function () {
      return this.$store.state['custom-notification']?.customNotificationParams?.buttonLink || ""
    },
    buttonCloseText: function () {
      return this.$store.state['custom-notification']?.customNotificationParams?.buttonText || "Закрыть"
    },

    buttonCloseComponent: function () {
      if (this.buttonCloseLink) {
        return "nuxt-link"
      }
      return "button"
    }
  },

  methods: {

    close: function () {
      this.$customNotification.close();
    }

  }
};
